export default "__VITE_ASSET__CK7lX0PM__"